module.exports = __webpack_public_path__ + "static/media/DMSans-SemiBold.68dca5b9.woff";